import {useEffect,useState} from 'react';
import {supabase} from './supabaseClient';
export async function request(action,body){
  const {data:{session}}=await supabase.auth.getSession();
  const response=await fetch(`/api/walkthrough?action=${action}`,{method:body?'POST':'GET',headers:{...(body?{'Content-Type':'application/json'}:{}),...(session?.access_token?{Authorization:`Bearer ${session.access_token}`}:{})},...(body?{body:JSON.stringify(body)}:{})});
  const data=await response.json().catch(()=>({error:'Walkthrough backend unavailable. Retry once the deployment finishes.'}));
  if(!response.ok)throw Error(data.error||'Request failed');return data;
}
export function useWalkthroughSession(userId){
  const [state,setState]=useState({unlocked:false,error:'',processingConfigured:false});
  useEffect(()=>{
    let active=true,controller;
    async function sync(session){
      if(!active)return;controller?.abort();controller=new AbortController();
      if(!session){fetch('/api/walkthrough?action=session',{method:'DELETE'}).catch(()=>{});if(active)setState({unlocked:false,error:'',processingConfigured:false});return;}
      try{const response=await fetch('/api/walkthrough?action=session',{method:'POST',headers:{Authorization:`Bearer ${session.access_token}`},signal:controller.signal});const data=await response.json();if(!response.ok)throw Error(data.error||'Could not verify sign-in');if(active)setState({...data,unlocked:true,error:''});}catch(e){if(active&&e.name!=='AbortError')setState({unlocked:false,error:e.message,processingConfigured:false});}
    }
    supabase.auth.getSession().then(({data})=>sync(data.session));
    const {data:{subscription}}=supabase.auth.onAuthStateChange((_event,session)=>{sync(session);});
    return()=>{active=false;controller?.abort();subscription.unsubscribe();};
  },[userId]);
  return state;
}
export async function evidencePhoto(path){
  const response=await fetch(`/api/walkthrough?action=media&path=${encodeURIComponent(path)}`);
  if(!response.ok)throw Error('Could not load the selected evidence photo. Refresh sign-in and retry.');
  const blob=await response.blob();if(!blob.type.startsWith('image/')||blob.size>2*1024*1024)throw Error('Selected evidence photo is invalid.');
  return new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=reject;reader.readAsDataURL(blob);});
}
